import { DatePartsPicker } from "@/components/hr/DatePartsPicker";
import { TimePickerField } from "@/components/hr/TimePickerField";
import { Label } from "@/components/ui/label";

type GatePassDateTimeFieldsProps = {
  date: string;
  time: string;
  onDateChange: (next: string) => void;
  onTimeChange: (next: string) => void;
  disabled?: boolean;
  timeId?: string;
};

/** Shared Delivery Date + Time fields used by gate pass dialog and create-sale card. */
export function GatePassDateTimeFields({
  date,
  time,
  onDateChange,
  onTimeChange,
  disabled = false,
  timeId = "gate-pass-delivery-time",
}: GatePassDateTimeFieldsProps) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <div className="space-y-2">
        <Label className="text-xs text-muted-foreground">
          Delivery Date <span className="text-destructive">*</span>
        </Label>
        <DatePartsPicker
          value={date}
          onChange={onDateChange}
          displayFormat="PPP"
          placeholder="Select delivery date"
          className="w-full"
          disabled={disabled}
        />
      </div>
      <TimePickerField
        id={timeId}
        label="Delivery Time"
        required
        plain
        value={time}
        onChange={onTimeChange}
      />
    </div>
  );
}
